import { render, staticRenderFns } from "./mapForm.vue?vue&type=template&id=2bbfdf0d&scoped=true&"
import script from "./mapForm.vue?vue&type=script&lang=js&"
export * from "./mapForm.vue?vue&type=script&lang=js&"
import style0 from "./mapForm.vue?vue&type=style&index=0&id=2bbfdf0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbfdf0d",
  null
  
)

export default component.exports